<!-- DOC-62 §4.1 — the seven figures, each exactly as the offer record states it.
     ⚠️ The charge is a FACILITY FEE, never interest (BRE-056 §3). -->
@let o = offer();
@let was = o.previous;
<dl class="facts offer-card" data-testid="offer-card">
  <div class="facts__row" [class.offer-card__changed]="changed().has('amount')">
    <dt>Amount</dt>
    <dd data-testid="offer-amount">
      {{ o.approved_amount | zar }}
      @if (was && changed().has('amount')) {
        <span class="offer-card__was">was {{ was.approved_amount | zar }}</span>
      }
    </dd>
  </div>
  <div class="facts__row" [class.offer-card__changed]="changed().has('fee')">
    <dt>Facility fee</dt>
    <dd data-testid="offer-fee">
      {{ o.facility_fee_amount | zar }} ({{ o.fee_percent }}%)
      @if (was && changed().has('fee')) {
        <span class="offer-card__was"
          >was {{ was.facility_fee_amount | zar }} ({{ was.fee_percent }}%)</span
        >
      }
    </dd>
  </div>
  <div class="facts__row" [class.offer-card__changed]="changed().has('total')">
    <dt>Total repayable</dt>
    <dd data-testid="offer-total">
      {{ o.total_repayable | zar }}
      @if (was && changed().has('total')) {
        <span class="offer-card__was">was {{ was.total_repayable | zar }}</span>
      }
    </dd>
  </div>
  <div class="facts__row" [class.offer-card__changed]="changed().has('instalment')">
    <dt>Instalment</dt>
    <dd data-testid="offer-instalment">
      {{ o.instalment_amount | zar }} {{ frequencyWord() }}
      @if (was && changed().has('instalment')) {
        <span class="offer-card__was"
          >was {{ was.instalment_amount | zar }} {{ wordFor(was.repayment_frequency) }}</span
        >
      }
    </dd>
  </div>
  <div class="facts__row" [class.offer-card__changed]="changed().has('term')">
    <dt>Term</dt>
    <dd data-testid="offer-term">
      {{ o.term_months }} months ({{ o.instalment_count }} {{ frequencyWord() }} instalments)
    </dd>
  </div>
  <div class="facts__row" [class.offer-card__changed]="changed().has('first_debit')">
    <dt>First debit date</dt>
    <dd data-testid="offer-first-debit">
      {{ o.first_debit_date | date: 'd MMMM y' }}
      @if (was && changed().has('first_debit')) {
        <span class="offer-card__was">was {{ was.first_debit_date | date: 'd MMMM y' }}</span>
      }
      @if (firstDebitSentence(); as sentence) {
        <span class="offer-card__note" data-testid="offer-first-debit-sentence">{{
          sentence
        }}</span>
      }
    </dd>
  </div>
  @if (o.expires_at && o.state === 'OPEN') {
    <div class="facts__row">
      <dt>Open until</dt>
      <dd data-testid="offer-open-until">{{ o.expires_at | date: 'd MMMM y' }}</dd>
    </div>
  }
</dl>
